import { useState, useEffect, useMemo, useCallback } from "react";
import { JobApplication } from "../Entities/job-application.entity";
import JobApplicationService from "../Services/job.application.service";
import AuthService from "../Services/auth.service";

export const useCandidateAnalytics = () => {
  const [applications, setApplications] = useState<JobApplication[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const jobApplicationService = useMemo(() => new JobApplicationService(), []);

  const fetchApplications = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      const user = AuthService.getInstance().getCurrentUser();
      if (!user?._id) {
        setError("User not found. Please log in again.");
        setLoading(false);
        return;
      }

      const data = await jobApplicationService.findAllJobApplicationByUserId(user._id);
      setApplications(data || []);
    } catch (err: any) {
      console.error("Error fetching applications:", err);
      const errorMessage = err?.response?.data?.message 
        ? `Failed to load analytics: ${err.response.data.message}`
        : err?.message 
        ? `Failed to load analytics: ${err.message}`
        : "Failed to load analytics data. Please check your connection and try again.";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [jobApplicationService]);

  useEffect(() => {
    fetchApplications();
  }, [fetchApplications]);

  return {
    applications,
    loading,
    error,
    refetch: fetchApplications,
  };
};
